import React from "react";
import { Tooltip } from 'react-tooltip';
//Assets
import autoAnswerColoredIcon from 'img/AutoresponderIcon.svg';
//Components
import { Visibility } from "components/Visibility";
import { AutomaticAnswerContent, IconsContent } from "../AutomaticAnswer/styles";
//Generics
import { IAutomaticAnswerBuget } from "./interface";
import { generateRandomId } from "utils/GenerateRandomId";

export const AutomaticAnswerBudget: React.FC<IAutomaticAnswerBuget> = (props) => {
  const { budget } = props;

  const tooltipId = generateRandomId("TooltipAutoAnswer");

  return (
    <IconsContent>
      <Visibility visible={budget.autoAnswer}>
        <AutomaticAnswerContent data-tooltip-id={tooltipId} data-tooltip-content={budget.autoAnswer ? "Resposta Automática" : undefined}>
          <img src={autoAnswerColoredIcon} />
        </AutomaticAnswerContent>
      </Visibility>
      <Tooltip id={tooltipId} variant="light" />
    </IconsContent>
  );
};